module.exports = __webpack_public_path__ + "static/media/plus-button.b8682631.png";